<template>
  <div></div>
</template>

<script>
import { Logger } from "aws-amplify"
const logger = new Logger("Permissions")
import { UserPermissions, GetUserByEmail } from '@/services/API.js'
import { mapMutations, mapState } from "vuex"
import Auth from "@/services/Auth"

export default { 
  computed: {
    ...mapState("permissions", ["userPermissions"]),
  },

  mounted () {
    this.fetchPermissions()
    
    // expose the permissions function for the web component
    window.$userCan = (permission) => {
      return this.$can(permission)
    }
  },
  
  destroyed () {
    window.EventBus.$off('getPermissions')
  },

  methods: {
    ...mapMutations('permissions', ['setPermissions']),

     async fetchPermissions () {
      // we need the id of the user that is currently logged in to fetch their permissions
      let user = await Auth.currentSession()
			let currentAuthenticatedUser = user.User
      let res = await GetUserByEmail(currentAuthenticatedUser.email)

      logger.debug("currently auth user", res)

      UserPermissions({users: [res.id]}).then(res => {
        let curPermissions = res.users[0].user_permission_document
        let allowedPermissions = res.users[0].role_permission_document
        let usersList = allowedPermissions.filter(p => !curPermissions.includes(p))
        let newPermissions = {}

        usersList.forEach(i => {
          newPermissions[i.split(':')[1]] = true
        })
       
        logger.debug("permissions fetched", res)
        this.setPermissions(newPermissions)
      }).catch(err => {
        logger.debug("permissions error", err) 
      })
    },
  }
}
</script>
